export default __webpack_public_path__ + "static/Image041_small-09b2e7e10ca2a6b714039dc857d0f2d1.png";